(() => {
  const isPharmacyTeam = () =>
    document.body && document.body.classList.contains('page-pharmacy-team');

  const getHeader = () =>
    document.querySelector('#shopify-section-header .header_main_area.mounjaro-header');

  const getWrap = () => document.getElementById('shopify-section-header');

  const unhide = () => {
    const header = getHeader();
    const wrap = document.getElementById('mounjaro-announcement-wrap');

    if (header) header.classList.remove('mj-hidden');
    if (wrap) wrap.classList.remove('mj-hidden');
    // In case anything else gets the class
    document.querySelectorAll('.mj-hidden').forEach(el => {
      // Only unhide header/announcement related elements
      if (el.id === 'mounjaro-announcement-wrap' || el.closest('#shopify-section-header')) {
        el.classList.remove('mj-hidden');
      }
    });
  };

  const setSpacer = () => {
    const header = getHeader();
    const wrap = getWrap();
    if (!header || !wrap) return;

    const h = Math.ceil(header.getBoundingClientRect().height || 0);
    if (h > 0) {
      wrap.style.height = `${h}px`;
      wrap.style.minHeight = `${h}px`;
      wrap.style.overflow = 'visible';
    }
  };

  const onTopGuard = () => {
    const y = window.scrollY || 0;
    if (y <= 2) unhide(); // ensure visible when at top on all breakpoints
  };

  const init = () => {
    if (!isPharmacyTeam()) return;

    // initial
    setSpacer();
    onTopGuard();

    // observe header size changes
    const header = getHeader();
    if (header && 'ResizeObserver' in window) {
      const ro = new ResizeObserver(() => setSpacer());
      ro.observe(header);
    }

    // keep it visible at top (some scripts hide it again)
    window.addEventListener('scroll', onTopGuard, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('load', () => { if (isPharmacyTeam()) { setSpacer(); onTopGuard(); } }, { passive: true });
  window.addEventListener('resize', () => { if (isPharmacyTeam()) { setSpacer(); onTopGuard(); } }, { passive: true });
  window.addEventListener('pageshow', () => { if (isPharmacyTeam()) { setSpacer(); onTopGuard(); } }, { passive: true });
})();